<template>
  <div class="welcome-box">
      <div class="img">
        <img src="../assets/images/welcome.png" alt="" width="200px" height="200px">
        <div class="text">请使用 微信 / 支付宝 / 浏览器 / 任意APP 扫码查看</div>
      </div>
  </div>
</template>

<script>

export default {
name: 'Welcome',
components: {
},
created(){
  document.title = '请使用手机扫码查看'
},
mounted(){
  if(this.$store.state.userAgent === 'Mobile'){
    this.$router.push('/')
  }
},
data(){
    return {
    }
},
methods:{
},
props:{

}
}
</script>

<style scoped lang="scss">
.welcome-box {
  background-image: linear-gradient(-20deg,#fc6076,#ff9a44);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  .img {
    .text {
      margin: 15px 0;
    }
  }
}
</style>
